import type { CardProps } from "@heroui/react";

import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import React from "react";
import { Card, CardBody, CardHeader } from "@heroui/react";

export type FeatureCardProps = CardProps & {
  key: string;
  title: string;
  icon: string;
  descriptions: string[];
};

export type FeatureCardPropsWithSelect = FeatureCardProps & {
  onSelectFn: (description: string) => void;
};

export const FeatureCard = React.forwardRef<HTMLDivElement, FeatureCardPropsWithSelect>(
  ({ title, icon, descriptions, onSelectFn, ...props }, ref) => {
    const { t } = useTranslation();

    return (
      <Card ref={ref} className="bg-content2" shadow="none" {...props}>
        <CardHeader className="flex flex-col gap-2 px-4 pb-4 pt-6">
          <Icon icon={icon} />
          <p className="text-medium text-content2-foreground">{t(title)}</p>
        </CardHeader>
        <CardBody className="flex flex-col gap-2">
          {descriptions.map((description, index) => (
            <div
              key={index}
              className="flex min-h-[50px] cursor-pointer rounded-medium bg-content3 px-3 py-2 text-content3-foreground hover:bg-content4"
              role="button"
              tabIndex={0}
              onClick={() => onSelectFn(description)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onSelectFn(description);
                }
              }}
            >
              <p className="text-small">{t(description)}</p>
            </div>
          ))}
        </CardBody>
      </Card>
    );
  },
);

FeatureCard.displayName = "FeatureCard";

export const FeatureCards = ({
  cards,
  onSelectFn,
}: {
  cards: FeatureCardProps[];
  onSelectFn: (prompt: string) => void;
}) => {
  return (
    <div className="flex h-full flex-col justify-center gap-4 p-4">
      <>
        {/*
        <div className="flex w-full flex-col items-center justify-center gap-2">
          <Image
            height={100}
            src={`/brands/${brand.prefix || "webuild"}/pathfinder.svg`}
            width={100}
          />
          <h1 className="text-xl font-medium text-default-700">
            {t("How can I help you today?")}
          </h1>
        </div>
        */}
        <div className="grid grid-cols-1 gap-4 pt-10 sm:grid-cols-2 md:grid-cols-3">
          {Array.isArray(cards) &&
            cards.map((card) => (
              <FeatureCard
                key={card.key}
                descriptions={card.descriptions}
                icon={card.icon}
                title={card.title}
                onSelectFn={onSelectFn}
              />
            ))}
        </div>
      </>
    </div>
  );
};
